import React from "react";
import cn from "classnames";
import styles from "./Checkbox.module.scss";
export function Checkbox({ checked, label, className, setChecked, disabled = false }) {
    return (React.createElement("div", { className: cn(styles.container, className) },
        React.createElement("input", { type: "checkbox", checked: checked, onChange: setChecked === null || setChecked === void 0 ? void 0 : setChecked.toggle, disabled: disabled }),
        label && React.createElement("label", { onClick: setChecked === null || setChecked === void 0 ? void 0 : setChecked.toggle }, label)));
}
